import Branding from "@/utils/branding.ts";

interface TemplateVariables {
  logo: string;
  title: string;
  titleIframe: string;
  favicon: string;
  svgFavicon: string;
  pwaManifest?: string;
  customHeaderCode?: string;
  loadMessages: string
}

export interface BrandingData {
  logo: string;
  logoClasses?: string;
  name: string;
  mainSite: string;
  sidebarShowName: boolean;
  supportEnabled: boolean;
  language: string;
  googleAuthEnabled: boolean;
  yaMetricsID: number|null;
  templateVars: TemplateVariables;
}

let loadMessagesRU = JSON.stringify([
  'Инициализация...',
  'Загрузка компонентов...',
  'Подключение зависимостей...',
  'Подготовка интерфейса...',
  'Почти готово...',
  'Готово!'
]);

let loadMessagesEN = JSON.stringify([
    "Initializing...",
    "Loading components...",
    "Connecting dependencies...",
    "Preparing interface...",
    "Almost ready...",
    "All set!"
  ]
);

export const platformMostAI = "Most AI";
export const platformWizyChat = "BrowserCloud";
export const platformSimpleAI = "SimpleAI"

const vkAdsCloudPayments = `
<script src="https://widget.cloudpayments.ru/bundles/cloudpayments.js"></script>
<script type="text/javascript">
var _tmr = window._tmr || (window._tmr = []);
_tmr.push({id: "3652691", type: "pageView", start: (new Date()).getTime()});
(function (d, w, id) {
  if (d.getElementById(id)) return;
  var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
  ts.src = "https://top-fwz1.mail.ru/js/code.js";
  var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
  if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
})(document, window, "tmr-code");
</script>
<noscript><div><img src="https://top-fwz1.mail.ru/counter?id=3652691;js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div></noscript>
`

let platform: null | string = null;
let platformLang: null | string = null;

export const isPlatform = (platformName: string|string[]): boolean => {
  if (!platform) {
    platform = Branding().name;
  }

  if (typeof platformName == "object") {
    return platformName.includes(platform)
  }

  return platform == platformName;
};

export const isPlatformLang = (lang: string): boolean => {
  if (!platformLang) {
    platformLang = Branding().language;
  }
  return lang == platformLang;
};

export const domains: { [key: string]: BrandingData } = {
  localhost: {
    name: platformWizyChat, //"DevWizyChat",
    mainSite: "http://localhost",
    sidebarShowName: false,
    logo: "/account/logo/multiagent.svg",
    logoClasses: "max-h-[40px] lg:max-h-[40px]",
    supportEnabled: true,
    language: "en",
    googleAuthEnabled: true,
    yaMetricsID: null,
    templateVars: {
      logo: "/account/logo/multiagent.svg",
      title: "BrowserCloud | Admin",
      titleIframe: "WizyChat: AI-powered Assistant",
      favicon: "/assets/images/favicon.ico",
      svgFavicon: "/assets/images/favicon.svg",
      loadMessages: loadMessagesRU
    },
  },
  "app.browsercloud.io": {
    name: platformWizyChat,
    mainSite: "https://browsercloud.io",
    sidebarShowName: true,
    logo: "https://browsercloud.io/logo.svg",
    logoClasses: "h-[32px] hidden md:inline",
    supportEnabled: true,
    language: "en",
    googleAuthEnabled: true,
    yaMetricsID: null,
    templateVars: {
      logo: "https://browsercloud.io/logo.svg",
      title: "BrowserCloud | Admin",
      titleIframe: "BrowserCloud AI: AI-powered browser agents",
      favicon: "https://browsercloud.io/logo.svg",
      svgFavicon: "https://browsercloud.io/logo.svg",
      loadMessages: loadMessagesEN
    },
  },
};
